
    import {Component, Vue, Watch} from 'vue-property-decorator'
    import {GetPreReturnOrderParamsDto, getReturnablePackagesList, ReturnPackageListApi} from "@/api/shopOrder";
    import math from "@/core/math";
    import {Action, Getter} from "vuex-class";
    import StepperTemp from "@/components/StepperTemp/index.vue";

    @Component({
        name: 'ChoosePackage',
        components: { StepperTemp }
    })
    export default class ChoosePackage extends Vue {
        @Getter companyId!: string
        @Action setPreReturnOrderParams!: (val: GetPreReturnOrderParamsDto) => void;

        checkedAll = false
        packageList: ReturnPackageListApi[] = []
        totalClass = 0
        totalQuantity = 0
        totalAmount = 0
        checkResult: { orderDtlId?: string; returnAmount?: number }[] = []
        params: { currRouteId?: string; orderId?: string } = {}

        @Watch('packageList', {deep: true})
        changePackageList (val: ReturnPackageListApi[]) {
            this.checkResult = []
            const {classSum, quantitySum, amountSum} = this.calcSum(val)
            this.totalClass = classSum
            this.totalQuantity = quantitySum
            this.totalAmount = amountSum
            if (val && val.length > 0) {
                val.forEach((item) => {
                    if (item.isChecked) {
                        this.checkResult.push({
                            orderDtlId: item.orderDtlId,
                            returnAmount: item.saleAmount
                        })
                    }
                })
            }
            this.checkedAll = this.totalClass === val.length
        }

        created () {
            this.params.currRouteId = this.$route.query.currRouteId as string
            this.params.orderId = this.$route.query.orderId as string
            this.getPackageList()
        }

        getPackageList () {
            getReturnablePackagesList(this.params).then((res) => {
                this.packageList = res.data || []
                if (this.packageList && this.packageList.length > 0) {
                    this.packageList.forEach((item) => {
                        item.isChecked = false
                        item.isEdit = false
                        item.saleAmount = 1
                    })
                }
                this.packageList = JSON.parse(JSON.stringify(this.packageList))
            })
        }

        /**
         * 以店铺为单位，计算种类，数量，金额
         * @param packageList 需计算的店铺数据
         */
        calcSum(packageList: ReturnPackageListApi[]) {
            // 种类
            let classSum = 0
            // 数量
            let quantitySum = 0
            // 金额
            let amountSum = 0
            if (packageList && packageList.length > 0) {
                packageList.forEach((item: ReturnPackageListApi) => {
                    if (item.isChecked) {
                        classSum = Number(math.mathAdd(classSum, 1))
                        quantitySum = Number(math.mathAdd(quantitySum, item.saleAmount))
                        if (item.salePrice) {
                            amountSum = Number(math.mathAdd(amountSum, math.mathMultiply(item.salePrice, item.saleAmount || 0)))
                        }
                    }
                })
            }
            return {classSum, quantitySum, amountSum}
        }

        /**
         * 切换数量编辑状态
         * @param index 商品套餐下标
         */
        changeEdit(index) {
            this.$set(this.packageList[index], 'isEdit', true)
        }

        handleEmpty () {}

        // 全选
        changeAll() {
            this.packageList.forEach((item) => {
                item.isChecked = this.checkedAll
            })
            this.packageList = JSON.parse(JSON.stringify(this.packageList))
        }

        toSubmitOrder () {
            if (this.checkResult.length <= 0) {
                return this.$toast('请先选择订单')
            }
            const data = {
                customerId: this.companyId,
                orderId: this.params.orderId,
                currRouteId: this.params.currRouteId,
                returnOrderDtlList: this.checkResult
            }
            this.setPreReturnOrderParams(data)
            this.$router.push({
                path: '/submitReturnOrder'
            })
        }

        /**
         * 商品数量改变时触发
         * @param index 商品列表下标
         * @param value 选择的商品数量
         */
        changeQuantity (index, value) {
            this.$set(this.packageList[index], 'saleAmount', value)
        }
    }
